import { useState } from "react";
import { useTranslation } from "react-i18next";
import { showSelfLabel } from "utils/helper";

import Plus from "../../assets/img/icons/plus_primary.svg";
import FirstRoundLetterComp from "../../components/FirstRoundLetter/FirstRoundLetter";
import ToggleButton from "../../components/ToggleButton/ToggleButton";
import HelpTooltip from "../../components/Tooltip/HelpTooltip";
import { ButtonIcon } from "../../styledComponents/buttons";
import {
  CommonFlex,
  CommonGrid,
  CommonText,
  FirstWordRound,
  MailSendSection,
  ResendInvite,
  RoundMiniImage,
  TableText,
  TextInputSection,
} from "../../styledComponents/common";
import {
  AssigneesManageImgTextGrid,
  AssigneesManageRoundImage,
} from "../../styledComponents/createProject";
import {
  ActivityTextSection,
  RadioButton,
  TimesheetApprovalSettingsBadge,
} from "../../styledComponents/members";
import {
  UserDotCircle,
  UserDotDivAssigneesManageRoundImageComp,
} from "../LiveFeed/CurrentlyTracking/currentlyTrackingStyles";

export const ApprovalSettingsSection = props => {
  const {
    margin,
    active,
    hasTooltip,
    handleChange,
    memberId,
    isAdmin,
    fontSize,
  } = props;

  const handleClick = () => {
    if (memberId) {
      handleChange(memberId, !active);
    }
  };
  return (
    <CommonFlex margin={margin || "10px 0 0 0"} gap="12px">
      <CommonText fontSize={fontSize} $label fontWeight={!hasTooltip && "500"}>
        Timesheet Approval
      </CommonText>
      {hasTooltip && (
        <HelpTooltip toolTipText="Control whether this member will require timesheet approval or not." />
      )}
      {isAdmin ? (
        <ToggleButton
          active={active}
          handleClick={handleClick}
          margin={hasTooltip && "0 0 0 10px"}
        />
      ) : (
        <TimesheetApprovalSettingsBadge active={active}>
          {active ? "ON" : "OFF"}
        </TimesheetApprovalSettingsBadge>
      )}
    </CommonFlex>
  );
};

export const AttendanceSelfieStatusSection = props => {
  const { margin, active, hasTooltip, handleChange, memberId, notMember } =
    props;

  const handleClick = value => {
    if (memberId && notMember) {
      handleChange(memberId, value);
    }
  };
  return (
    <TextInputSection>
      <CommonFlex gap="12px">
        <CommonText $label fontWeight={!hasTooltip && "500"}>
          Enable Attendance Selfie
        </CommonText>
        {hasTooltip && (
          <HelpTooltip toolTipText="Enable or disable the attendance selfie requirement for this individual member." />
        )}
      </CommonFlex>
      <CommonFlex
        gap="10px"
        margin="0 auto 0 0"
        style={{ cursor: `pointer` }}
        onClick={() => handleClick(true)}
      >
        <RadioButton active={active} />
        <CommonText paddingLeft="45px" fontWeight="500">
          Enable
        </CommonText>
      </CommonFlex>
      <CommonFlex
        gap="10px"
        margin="0 auto 0 0"
        style={{ cursor: `pointer` }}
        onClick={() => handleClick(false)}
      >
        <RadioButton active={!active} />
        <CommonText fontWeight="500">Disable</CommonText>
      </CommonFlex>
    </TextInputSection>
  );
};

export const GeofenceStatusSection = props => {
  const { margin, active, hasTooltip, handleChange, memberId, notMember } =
    props;

  const handleClick = value => {
    if (memberId && notMember) {
      handleChange(memberId, value);
    }
  };
  return (
    <TextInputSection>
      <CommonFlex gap="12px">
        <CommonText $label fontWeight={!hasTooltip && "500"}>
          Enable Geofence Status for Time Clock
        </CommonText>
        {hasTooltip && (
          <HelpTooltip toolTipText="Manage whether this member operates from the office or remotely." />
        )}
      </CommonFlex>
      <CommonFlex
        gap="10px"
        margin="0 auto 0 0"
        style={{ cursor: `pointer` }}
        onClick={() => handleClick(false)}
      >
        <RadioButton active={!active} />
        <CommonText paddingLeft="45px" fontWeight="500">
          Remote User
        </CommonText>
      </CommonFlex>
      <CommonFlex
        gap="10px"
        margin="0 auto 0 0"
        style={{ cursor: `pointer` }}
        onClick={() => handleClick(true)}
      >
        <RadioButton active={active} />
        <CommonText fontWeight="500">Office User</CommonText>
      </CommonFlex>
    </TextInputSection>
  );
};

export const CommImageNameComp = ({
  hoverUnderline = false,
  size,
  imgSource,
  name,
  index,
  color,
  fontSize,
  isOnline,
  email,
  userId,
  selectedMemberId,
  location,
  designation,
  toggleDesignationModal,
  showEmail = false,
  showAddDesignation = true,
  showDesignationButtonOnHover = false,
}) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  const shouldShowAddDesignation = !designation && showAddDesignation;
  const shouldUseActivityLayout =
    !!email || !!designation || !!location || shouldShowAddDesignation;

  return (
    <AssigneesManageImgTextGrid
      hoverUnderline={hoverUnderline}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <AssigneesManageRoundImage imageSize={size}>
        {imgSource && imgSource[0] !== "/" ? (
          <RoundMiniImage src={imgSource} alt="" imageSize={size} />
        ) : (
          <FirstRoundLetterComp
            text={name}
            backColor={index}
            color={color}
            size={size}
            fontSize={fontSize}
            isOnline={isOnline}
          />
        )}
        {isOnline && (
          <UserDotDivAssigneesManageRoundImageComp>
            <UserDotCircle />
          </UserDotDivAssigneesManageRoundImageComp>
        )}
      </AssigneesManageRoundImage>

      {shouldUseActivityLayout ? (
        <ActivityTextSection style={{ alignContent: "center" }}>
          <TableText
            color="#000E2A"
            fontWeight="600"
            hoverUnderline={hoverUnderline}
          >
           {showSelfLabel(userId, name)}
          </TableText>
          {showEmail && email ? (
            <TableText fontSize="12px" name>
              {email}
            </TableText>
          ) : !showEmail && designation ? (
            <CommonText color="#353A46" fontSize="12px" name>
              {designation}
            </CommonText>
          ) : !showEmail && email ? (
            <TableText color="#353A46" fontSize="12px" name>
              {email}
            </TableText>
          ) : null}
          {location && (
            <TableText fontSize={fontSize} hoverUnderline={hoverUnderline}>
              {location}
            </TableText>
          )}
          {shouldShowAddDesignation &&
            showDesignationButtonOnHover && (
              <CommonText
                fontSize="12px"
                color="#2266EF"
                margin="0 0 0 0"
                fontWeight="500"
                style={{ cursor: "pointer" }}
                onClick={e => {
                  e.stopPropagation();
                  toggleDesignationModal(userId);
                }}
              >
                <ButtonIcon src={Plus} alt="plus" size="12px" /> {` `}
                {t("add_designation")}
              </CommonText>
            )}
        </ActivityTextSection>
      ) : (
        <TableText name fontSize={fontSize} hoverUnderline={hoverUnderline}>
          {/* {selectedMemberId === userId
          ? name
          : showSelfLabel(userId, name)} */}
          {showSelfLabel(userId, name)}
        </TableText>
      )}
    </AssigneesManageImgTextGrid>
  );
};

export const CommAssigneesImageNameComp = ({
  hoverUnderline = false,
  size,
  imgSource,
  name,
  index,
  color,
  fontSize,
  isOnline,
  email,
  userId,
  selectedMemberId,
  location,
  profession,
  phone,
}) => {
  return (
    <CommonGrid gap="10px" alignItems="stretch" columns="1fr 1fr">
      <AssigneesManageImgTextGrid hoverUnderline={hoverUnderline}>
        <AssigneesManageRoundImage imageSize={size}>
          {imgSource[0] !== "/" ? (
            <RoundMiniImage src={imgSource} alt="" imageSize={size} />
          ) : (
            <FirstRoundLetterComp
              text={name}
              backColor={index}
              color={color}
              size={size}
              fontSize={fontSize}
              isOnline={isOnline}
            />
          )}
          {isOnline && (
            <UserDotDivAssigneesManageRoundImageComp>
              <UserDotCircle />
            </UserDotDivAssigneesManageRoundImageComp>
          )}
        </AssigneesManageRoundImage>

        {profession && (
          <ActivityTextSection style={{ alignContent: "center" }}>
            <TableText name hoverUnderline={hoverUnderline}>
              {name}
            </TableText>
            <TableText fontWeight="500">{profession}</TableText>
          </ActivityTextSection>
        )}
      </AssigneesManageImgTextGrid>
      <CommonFlex
        gap="6px"
        direction="column"
        alignItems="flex-start"
        justifyContent="flex-start"
      >
        {phone && (
          <CommonText fontSize="13px">Phone number: {phone}</CommonText>
        )}
        {email && <CommonText fontSize="13px">Email: {email}</CommonText>}
      </CommonFlex>
    </CommonGrid>
  );
};

export const CommImageInviteComp = props => (
  <AssigneesManageImgTextGrid>
    <AssigneesManageRoundImage imageSize={props.size}>
      <FirstRoundLetterComp
        text={props.member.email}
        backColor={props.index}
        color={props.member.color}
      />
    </AssigneesManageRoundImage>
    <MailSendSection>
      <TableText name>{props.member.email}</TableText>
      <ResendInvite onClick={() => props.resendInvite(props.member)}>
        Resend Invitation
      </ResendInvite>
    </MailSendSection>
  </AssigneesManageImgTextGrid>
);

export const CommFirstRoundLetterComp = ({
  text,
  backColor,
  size,
  fontSize,
}) => {
  const colorList = [
    { color: "#9A96F9" },
    { color: "#73C0FF" },
    { color: "#F9828B" },
    { color: "#F9D059" },
  ];
  let selectedIndex = 0;
  if (backColor < 4) {
    selectedIndex = backColor;
  } else {
    selectedIndex = backColor % 4;
  }

  return (
    <FirstWordRound
      backColor={colorList[selectedIndex].color}
      size={size}
      fontSize={fontSize}
    >
      {" "}
      {text.slice(0, 1).toUpperCase()}{" "}
    </FirstWordRound>
  );
};
export const CommFirstRoundLetterCompNew = ({ text, backColor, size }) => {
  const colorList = [
    { color: "#9A96F9" },
    { color: "#73C0FF" },
    { color: "#F9828B" },
    { color: "#F9D059" },
  ];
  const getInitials = string => {
    if (string === "" || string === undefined) return "";
    var names = string.split(" "),
      initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  };
  let selectedIndex = 0;
  if (backColor < 4) {
    selectedIndex = backColor;
  } else {
    selectedIndex = backColor % 4;
  }

  return (
    <AssigneesManageImgTextGrid>
      <FirstWordRound backColor={colorList[selectedIndex].color} size={size}>
        {" "}
        {getInitials(text)}{" "}
      </FirstWordRound>
      <TableText name>{text}</TableText>
    </AssigneesManageImgTextGrid>
  );
};
